module.exports = __webpack_public_path__ + "static/bg_header_cip.0650d9d9.png";